import {
  RESET_CREATE_TRANSACTION_DETAILS_AND_RES_OBJ,
  SET_PAYMENT_METHOD,
} from "../action.js";
import { paymentMethod } from "./initial-store.js";

const initialState = paymentMethod;

function paymentMethodReducer(state = initialState, action) {
  let newState;
  switch (action.type) {
    case SET_PAYMENT_METHOD:
      newState = action.payload;
      return newState;
    case RESET_CREATE_TRANSACTION_DETAILS_AND_RES_OBJ:
      return null;
    default:
      return state;
  }
}

export default paymentMethodReducer;
